
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="currentColor">
	<path
		d="M13.1538 2.25062C12.2316 2.25062 11.3913 2.59173 10.7413 3.14742L10.7382 3.1437L10.6966 3.18649L10.3239 3.55861L8.8125 5.07064L7.30109 3.55861L6.92836 3.18649L6.8868 3.1437L6.8837 3.14742C6.21281 2.56923 5.35681 2.25081 4.47115 2.25C3.48424 2.25 2.53775 2.64205 1.8399 3.3399C1.14205 4.03775 0.75 4.98424 0.75 5.97115C0.75 7.09928 1.2536 8.1071 2.04558 8.78931L8.8125 15.5568L15.5794 8.78931C15.9858 8.44089 16.312 8.00869 16.5356 7.52235C16.7592 7.03602 16.875 6.50706 16.875 5.97177C16.875 4.98486 16.483 4.03837 15.7851 3.34052C15.0872 2.64267 14.1408 2.25062 13.1538 2.25062Z" />
</svg>
    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'FollowFilled',
    }) as DefineComponent
    </script>
    